import {
  Chart,
  ChartAxisDefaults,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartLegend,
  ChartSeries,
  ChartSeriesItem,
} from "@progress/kendo-react-charts";
import { useEffect, useState } from "react";

const BBSStats = ({ statsData }: any) => {
  const [projects, setProjects] = useState<any[]>();
  const [bbsCounts, setBBSCounts] = useState<number[]>([
    2, 4, 10, 5, 5, 2, 3, 4, 0, 1,
  ]);

  useEffect(() => {
    const data = Array.from(new Set(statsData.map((x: any) => x.name))).sort();

    const projects = Array.from(new Set(data.map((x: any) => x)));
    setProjects(projects);

    const bbsList = statsData
      .map((proj: any) => {
        return {
          project: proj.name,
          count: proj.bbs,
        };
      })
      .map((x: any) => x.count);

    setBBSCounts(bbsList);
  }, [statsData]);

  return (
    <>
      <div className="sm:px-4 px-3  flex-1">
        <Chart style={{ height: "300px" }}>
          <ChartLegend
            visible={false}
            position="bottom"
            orientation="horizontal"
            labels={{ font: "10px Cabin, sans-serif" }}
          />
          <ChartAxisDefaults labels={{ format: "##,#" }} />
          <ChartCategoryAxis>
            <ChartCategoryAxisItem
              categories={projects}
              majorGridLines={{ visible: false }}
              minorGridLines={{ visible: false }}
            ></ChartCategoryAxisItem>
          </ChartCategoryAxis>
          <ChartSeries>
            <ChartSeriesItem
              type="column"
              data={bbsCounts}
              name="BBS"
              color={"#DD915F"}
              tooltip={{ visible: true }}
            />
          </ChartSeries>
        </Chart>
      </div>
    </>
  );
};

export default BBSStats;
